import { forwardRef, useRef } from 'react'
import { Link } from 'react-router-dom'

export default forwardRef(function Button({ className = '', disabled, children, ...props }, ref) {
    const input = useRef()
    const Div = props.href ? Link : 'button'
    return (
        <Div
            {...props}
            className={`flex items-center justify-center cursor-pointer rounded-lg border py-2 px-6 transition hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 dark:focus:ring-secondary ${
                disabled && 'opacity-50 cursor-not-allowed'
            } ${className}`}
            disabled={props.href ? undefined : disabled}
            aria-disabled={disabled || undefined}
            tabIndex={props.href && disabled ? -1 : undefined}
            ref={ref || input}
        >
            {children}
        </Div>
    )
})
